/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, ViewEncapsulation, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import { CommonService } from '../../shared/services/common.service';

export class VolumeTransferConfirmationModalContext {
  data: any;
  dialogClass: string = '';
}

@Component({
  selector: 'volume-transfer-confirmation-modal',
  templateUrl: './volume-transfer-confirmation-modal.component.html',
  styleUrls: ['./volume-transfer-confirmation-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
  // providers: [CommonService]
})

export class VolumeTransferConfirmationModalComponent implements OnInit {
  context!: VolumeTransferConfirmationModalContext;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  public contextData: any;
  public isFromEligibilityReset: boolean = false;

  constructor(public dialog: BsModalRef<VolumeTransferConfirmationModalContext>,private commonService: CommonService,) { }

  ngOnInit() { }

  getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
 }

  public closeModalWindow() {
    this.onClose.emit('closed');
    this.dialog.hide();
  }

  public confirmChange() {
    this.closeModal.emit('confirmed');
    this.dialog.hide();
  }
}
